import { __rest } from 'tslib';
import { defineComponent, ref, computed, provide, resolveComponent, openBlock, createElementBlock, normalizeClass, renderSlot, createElementVNode, mergeProps, createVNode, createCommentVNode, toDisplayString, createBlock } from 'vue';
import Hyperlink from '@ingka/hyperlink-vue';
import SSRIcon from '@ingka/ssr-icon-vue';
import notice from '@ingka/icons-shared/paths/notice-small';
import checkmark from '@ingka/icons-shared/paths/checkmark-small';

var script = defineComponent({
    name: 'FormField',
    components: { Hyperlink, SSRIcon },
    inheritAttrs: false,
    props: {
        /** Validation message object */
        validation: {
            type: Object,
            default: () => ({ type: 'error' })
        },
        /** When shouldValidate == false, helper message object */
        fieldHelper: {
            type: Object,
            default: () => ({})
        },
        /** Shows validation message if Form has validation rules set for this form field (if !valid) */
        shouldValidate: { type: Boolean, default: false },
        /** Defines if the formfield is valid or not */
        valid: { type: Boolean, default: false },
        /** Prefix all classes in every element with this string */
        prefix: { type: String, default: '' },
        /** Defines if the formfield is disabled or not */
        disabled: { type: Boolean, default: undefined },
        /** Defines character limit for input fields */
        characterLimit: { type: Number, default: 0 },
        withFieldset: {
            type: Boolean,
            default: false
        }
    },
    setup(props) {
        const characterCount = ref(0);
        const baseClass = computed(() => `${props.prefix}form-field`);
        const showValidation = computed(() => props.shouldValidate && !props.valid);
        const message = computed(() => ((showValidation.value ? props.validation : props.fieldHelper)));
        const messageProps = computed(() => {
            const _a = message.value, mProps = __rest(_a, ["id", "msg", "linkText", "link"]);
            return mProps;
        });
        const type = computed(() => message.value.type || showValidation.value && 'error');
        provide('valid', computed(() => props.valid));
        provide('shouldValidate', computed(() => props.shouldValidate));
        provide('characterCount', characterCount);
        provide('validationMessageId', computed(() => message.value.msg && !props.withFieldset ? message.value.id : null));
        let paths = computed(() => {
            if (!props.shouldValidate)
                return null;
            return props.valid ? checkmark : notice;
        });
        return { baseClass, paths, characterCount, message, messageProps, type };
    }
});

const _hoisted_1 = ["id", "aria-hidden"];

function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SSRIcon = resolveComponent("SSRIcon");
  const _component_Hyperlink = resolveComponent("Hyperlink");

  return (openBlock(), createElementBlock("div", {
    class: normalizeClass([
      _ctx.baseClass,
      {[`${_ctx.baseClass}--${_ctx.type}`]: _ctx.type,
       [`${_ctx.baseClass}--with-character-limit`]: _ctx.characterLimit,
       [`${_ctx.prefix}disabled`]: _ctx.disabled
      },
      _ctx.$attrs.class
    ])
  }, [
    renderSlot(_ctx.$slots, "default"),
    (_ctx.message.msg || _ctx.characterLimit)
      ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass(`${_ctx.baseClass}__content`)
        }, [
          createElementVNode("span", mergeProps({
            id: _ctx.message.id,
            "aria-hidden": _ctx.disabled,
            class: `${_ctx.baseClass}__message-wrapper`
          }, _ctx.messageProps), [
            (!_ctx.disabled && _ctx.paths && _ctx.type)
              ? (openBlock(), createElementBlock("span", {
                  key: 0,
                  class: normalizeClass(`${_ctx.baseClass}__icon-wrapper`)
                }, [
                  createVNode(_component_SSRIcon, {
                    class: normalizeClass(`${_ctx.baseClass}__icon`),
                    prefix: _ctx.prefix,
                    paths: _ctx.paths
                  }, null, 8 /* PROPS */, ["class", "prefix", "paths"])
                ], 2 /* CLASS */))
              : createCommentVNode("v-if", true),
            createElementVNode("span", {
              class: normalizeClass(`${_ctx.baseClass}__message`)
            }, toDisplayString(_ctx.message.msg), 3 /* TEXT, CLASS */),
            (_ctx.message.linkText && _ctx.message.link)
              ? (openBlock(), createBlock(_component_Hyperlink, {
                  key: 1,
                  prefix: _ctx.prefix,
                  url: _ctx.message.link,
                  text: _ctx.message.linkText
                }, null, 8 /* PROPS */, ["prefix", "url", "text"]))
              : createCommentVNode("v-if", true)
          ], 16 /* FULL_PROPS */, _hoisted_1),
          (_ctx.characterLimit > 0)
            ? (openBlock(), createElementBlock("span", {
                key: 0,
                class: normalizeClass([
          `${_ctx.baseClass}__character-limit`,
          {[`${_ctx.baseClass}__character-limit--error`]: _ctx.characterCount > _ctx.characterLimit}
        ])
              }, toDisplayString(_ctx.characterCount) + "/" + toDisplayString(_ctx.characterLimit), 3 /* TEXT, CLASS */))
            : createCommentVNode("v-if", true)
        ], 2 /* CLASS */))
      : createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}

script.render = render;
script.__file = "packages/vue/form-field/lib/FormField.vue";

export { script as default };
